<template>
  <div class="distributor-map-section">
    <div class="section-header">
      <h2 class="section-title">全国分销商网络</h2>
      <p class="section-subtitle">覆盖全国主要城市，为您提供专业的纹发设备和服务</p>
    </div>

    <!-- 统计信息 -->
    <div class="statistics-section">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="el-icon-location"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ totalDistributors }}</div>
          <div class="stat-label">分销商总数</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon province">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ provinceDistributors }}</div>
          <div class="stat-label">省代</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon city">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ cityDistributors }}</div>
          <div class="stat-label">市代</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon county">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ countyDistributors }}</div>
          <div class="stat-label">县代</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon franchise">
          <i class="el-icon-s-shop"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ franchiseDistributors }}</div>
          <div class="stat-label">加盟店</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon experience">
          <i class="el-icon-s-home"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ experienceDistributors }}</div>
          <div class="stat-label">体验馆</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon company">
          <i class="el-icon-s-flag"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ companyDistributors }}</div>
          <div class="stat-label">公司</div>
        </div>
      </div>
    </div>

    <!-- 地图展示 -->
    <div class="map-container" ref="mapContainer"></div>

    <!-- 查看更多按钮 -->
    <div class="view-more">
      <el-button type="primary" size="large" @click="goToDistributorPage">
        查看详细分销商信息
        <i class="el-icon-arrow-right"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
import { getEnabledDistributors, getLevelStatistics } from '@/api/distributor'
import * as echarts from 'echarts'
import chinaJson from '@/assets/china.json'

export default {
  name: 'DistributorMap',
  data() {
    return {
      distributors: [],
      totalDistributors: 0,
      provinceDistributors: 0,
      cityDistributors: 0,
      countyDistributors: 0,
      franchiseDistributors: 0,
      experienceDistributors: 0,
      companyDistributors: 0,
      mapChart: null
    }
  },
  mounted() {
    this.loadDistributors()
    this.loadStatistics()
  },
  beforeDestroy() {
    if (this.mapChart) {
      this.mapChart.dispose()
    }
  },
  methods: {
    async loadDistributors() {
      try {
        const res = await getEnabledDistributors()
        if (res && res.data && res.data.data) {
          this.distributors = res.data.data
          this.totalDistributors = res.data.data.length
          this.initMap()
        }
      } catch (error) {
        console.error('加载分销商数据失败:', error)
      }
    },
    
    async loadStatistics() {
      try {
        const res = await getLevelStatistics()
        if (res && res.data && res.data.data) {
          this.provinceDistributors = res.data.data['省代'] || 0
          this.cityDistributors = res.data.data['市代'] || 0
          this.countyDistributors = res.data.data['县代'] || 0
          this.franchiseDistributors = res.data.data['加盟店'] || 0
          this.experienceDistributors = res.data.data['体验馆'] || 0
          this.companyDistributors = res.data.data['公司'] || 0
        }
      } catch (error) {
        console.error('加载统计数据失败:', error)
      }
    },
    
    initMap() {
      if (!this.$refs.mapContainer) return
      
      try {
        echarts.registerMap('china', chinaJson)
        this.mapChart = echarts.init(this.$refs.mapContainer)
        
        const mapData = this.distributors
          .filter(d => d.longitude && d.latitude)
          .map(d => ({
            name: d.city,
            value: [d.longitude, d.latitude, 1],
            distributor: d
          }))
        
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: (params) => {
              if (params.data && params.data.distributor) {
                const d = params.data.distributor
                return `
                  <div style="padding: 10px;">
                    <h4 style="margin: 0 0 10px 0;">${d.name}</h4>
                    <p style="margin: 5px 0;"><strong>等级：</strong>${d.level}</p>
                    <p style="margin: 5px 0;"><strong>地址：</strong>${d.province} ${d.city}</p>
                    ${d.contactPhone ? `<p style="margin: 5px 0;"><strong>电话：</strong>${d.contactPhone}</p>` : ''}
                  </div>
                `
              }
              return params.name
            }
          },
          geo: {
            map: 'china',
            roam: true,
            label: {
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#f3f3f3',
                borderColor: '#516b91'
              },
              emphasis: {
                areaColor: '#ffd700'
              }
            }
          },
          series: [
            {
              name: '分销商',
              type: 'scatter',
              coordinateSystem: 'geo',
              data: mapData,
              symbolSize: 6,
              label: {
                formatter: '{b}',
                position: 'right',
                show: false,
                color: '#fff',
                fontSize: 12,
                fontWeight: 'bold'
              },
              itemStyle: {
                color: (params) => {
                  const level = params.data.distributor.level
                  if (level === '省代') return '#FF4500'
                  if (level === '市代') return '#1E90FF'
                  if (level === '县代') return '#32CD32'
                  if (level === '加盟店') return '#FFD700'
                  if (level === '体验馆') return '#FF69B4'
                  if (level === '公司') return '#8A2BE2'
                  return '#409eff'
                },
                shadowBlur: 10,
                shadowColor: (params) => {
                  const level = params.data.distributor.level
                  if (level === '省代') return '#FF4500'
                  if (level === '市代') return '#1E90FF'
                  if (level === '县代') return '#32CD32'
                  if (level === '加盟店') return '#FFD700'
                  if (level === '体验馆') return '#FF69B4'
                  if (level === '公司') return '#8A2BE2'
                  return '#409eff'
                }
              },
              emphasis: {
                label: {
                  show: true
                },
                itemStyle: {
                  shadowBlur: 20,
                  shadowColor: '#fff'
                }
              }
            }
          ]
        }
        
        this.mapChart.setOption(option)
        
        window.addEventListener('resize', () => {
          if (this.mapChart) {
            this.mapChart.resize()
          }
        })
      } catch (error) {
        console.error('初始化地图失败:', error)
      }
    },
    
    goToDistributorPage() {
      this.$router.push('/distributor')
    }
  }
}
</script>

<style scoped>
.distributor-map-section {
  padding: 60px 20px;
  max-width: 1400px;
  margin: 0 auto;
  background: #f8f9fa;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.section-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 16px;
  color: #666;
}

.statistics-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  margin-right: 20px;
}

.stat-icon.province {
  background: linear-gradient(135deg, #FF4500, #FF6347);
}

.stat-icon.city {
  background: linear-gradient(135deg, #1E90FF, #4169E1);
}

.stat-icon.county {
  background: linear-gradient(135deg, #32CD32, #228B22);
}

.stat-icon.franchise {
  background: linear-gradient(135deg, #FFD700, #FFA500);
}

.stat-icon.experience {
  background: linear-gradient(135deg, #FF69B4, #FF1493);
}

.stat-icon.company {
  background: linear-gradient(135deg, #8A2BE2, #9370DB);
}

.stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #333;
}

.stat-label {
  font-size: 14px;
  color: #666;
  margin-top: 5px;
}

.map-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  height: 600px;
  margin-bottom: 30px;
}

.view-more {
  text-align: center;
  padding: 20px 0;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 24px;
  }
  
  .statistics-section {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .map-container {
    height: 400px;
  }
}
</style>
